var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('v-layout',{staticClass:"mt-5",attrs:{"justify-center":""}},[_c('v-progress-circular',{attrs:{"color":_vm.colour,"indeterminate":""}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }